export const pvar = (variable, min, max, name, graph_max, low_is_bad) => {
  var calcFn;
  var graph;

  const lowIsBad = !!low_is_bad;

  if (min === null) {
    calcFn = _maxFn(max, name, lowIsBad);
    graph = { min: 0, max };
  } else if (max === null) {
    calcFn = _minFn(min, name, lowIsBad);
    graph = { min, max: graph_max || 100 };
  } else {
    calcFn = _minMaxFn(min, max, name, lowIsBad);
    graph = { min, max };
  }

  return { variable, calcFn, graph };
};

export const na = () => {
  return { hide: true, calcFn: _naFn };
};

export const showNonFinal = () => {
  return {};
};

export const naNonFinal = () => {
  return { hide: true };
};

const _naFn = () => { return { na: true }; };

const _maxFn = (max, name, lowIsBad) => (v) => {
  const result = {
    tooltip: `Max: ${max} | ${name} value: ${v}`
  };

  if (lowIsBad) {
    result.pass = false;
    result.close = false;
    result.under = v > max;
  } else {
    result.pass = v <= max;
    result.close = v <= max * 1.1;
    result.percentage = (v / max * 100).toFixed(0);
  }

  return result;
};

const _minFn = (min, name, lowIsBad) => (v) => {
  const result = {
    tooltip: `Min: ${min} | ${name} value: ${v}`
  };

  if (!lowIsBad) {
    result.under = v < min;
    result.pass = !result.under;
    result.close = false;
  } else {
    result.pass = v >= min;
    result.close = v >= min / 1.1;
  }

  return result;
};

const _minMaxFn = (min, max, name, lowIsBad) => (v) => {
  const result = {
    pass: v >= min && v <= max,
    tooltip: `Min: ${min} | Max: ${max} | ${name} value: ${v}`
  };

  if (lowIsBad) {
    result.close = v >= min / 1.1 && v < min;
    result.under = v > max;
  } else {
    result.close = v <= max * 1.1 && v > max;
    result.under = v < min;
    result.percentage = (v / max * 100).toFixed(0);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/utils/prescription_functions.js